
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Account: 'Account',
  AdminPermission: 'AdminPermission',
  AdminPointAward: 'AdminPointAward',
  AppNotification: 'AppNotification',
  AppPermission: 'AppPermission',
  Audit: 'Audit',
  Badge: 'Badge',
  BadgeEvent: 'BadgeEvent',
  BadgeOverride: 'BadgeOverride',
  BadgeToParticipant: 'BadgeToParticipant',
  Blast: 'Blast',
  Comment: 'Comment',
  Compliment: 'Compliment',
  CoreValueTag: 'CoreValueTag',
  Event: 'Event',
  Facility: 'Facility',
  FacilityOnPosts: 'FacilityOnPosts',
  Feed: 'Feed',
  FeedSubscription: 'FeedSubscription',
  HistoricalFacilitySavings: 'HistoricalFacilitySavings',
  HoursFileMapping: 'HoursFileMapping',
  RosterFileMapping: 'RosterFileMapping',
  IncentivePeriod: 'IncentivePeriod',
  IncentiveProgram: 'IncentiveProgram',
  IncentiveProgramsOnFacilities: 'IncentiveProgramsOnFacilities',
  IngestJob: 'IngestJob',
  JobSpecialty: 'JobSpecialty',
  EmploymentStatusMapping: 'EmploymentStatusMapping',
  LinkMappings: 'LinkMappings',
  MagicLinkOtp: 'MagicLinkOtp',
  OAuthClient: 'OAuthClient',
  OAuthAuthorizationCode: 'OAuthAuthorizationCode',
  OAuthAccessToken: 'OAuthAccessToken',
  OAuthRefreshToken: 'OAuthRefreshToken',
  OAuthConsent: 'OAuthConsent',
  Message: 'Message',
  ModuleData: 'ModuleData',
  ModuleRun: 'ModuleRun',
  Participant: 'Participant',
  ParticipantGroup: 'ParticipantGroup',
  ParticipantToFacility: 'ParticipantToFacility',
  ParticipantToGroup: 'ParticipantToGroup',
  ParticipantSurvey: 'ParticipantSurvey',
  ParticipantToIncentiveProgram: 'ParticipantToIncentiveProgram',
  PayDifferentialOrder: 'PayDifferentialOrder',
  PaySchedule: 'PaySchedule',
  PayScheduleDates: 'PayScheduleDates',
  PinnedPost: 'PinnedPost',
  PointTransaction: 'PointTransaction',
  PointTransactionStatusEvent: 'PointTransactionStatusEvent',
  Post: 'Post',
  PostParticipantTag: 'PostParticipantTag',
  Program: 'Program',
  ProgramPeriod: 'ProgramPeriod',
  RawSummedHoursData: 'RawSummedHoursData',
  RawRosterData: 'RawRosterData',
  Reaction: 'Reaction',
  ReferralReward: 'ReferralReward',
  Report: 'Report',
  RewardOption: 'RewardOption',
  ScheduleCycle: 'ScheduleCycle',
  ScheduleCycleDates: 'ScheduleCycleDates',
  ScheduleDates: 'ScheduleDates',
  ShiftPickupBadgeProgress: 'ShiftPickupBadgeProgress',
  ShiftPickupResults: 'ShiftPickupResults',
  SignUp: 'SignUp',
  SuperlativeQuestion: 'SuperlativeQuestion',
  SuperlativeVote: 'SuperlativeVote',
  Survey: 'Survey',
  SurveyChoice: 'SurveyChoice',
  SurveyQuestion: 'SurveyQuestion',
  SurveyResponse: 'SurveyResponse',
  SurveyResults: 'SurveyResults',
  SurveyToAccount: 'SurveyToAccount',
  Tag: 'Tag',
  TangoOrder: 'TangoOrder',
  TenureResults: 'TenureResults',
  Tier: 'Tier',
  TierHistory: 'TierHistory',
  Turnover: 'Turnover',
  User: 'User',
  View: 'View',
  ContentSource: 'ContentSource',
  Evidence: 'Evidence',
  PlayQuestion: 'PlayQuestion',
  Playbook: 'Playbook',
  PlaybookStep: 'PlaybookStep',
  PlaybookEligibility: 'PlaybookEligibility',
  PlaybookEnrollment: 'PlaybookEnrollment',
  ParticipantPlayStep: 'ParticipantPlayStep',
  PlaybookStepResponse: 'PlaybookStepResponse'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AccountScalarFieldEnum = {
  id: 'id',
  logoURL: 'logoURL',
  name: 'name',
  programName: 'programName',
  supportEmail: 'supportEmail',
  supportURL: 'supportURL',
  adminSupportURL: 'adminSupportURL',
  scheduleURL: 'scheduleURL',
  authProviderId: 'authProviderId',
  authTenantId: 'authTenantId',
  authProduct: 'authProduct',
  tangoCustomerIdentifier: 'tangoCustomerIdentifier',
  tangoaccountIdentifier: 'tangoaccountIdentifier',
  autoRedeemDefault: 'autoRedeemDefault',
  eligibleAllowedPoints: 'eligibleAllowedPoints',
  eligiblePointsRemovedQuarterly: 'eligiblePointsRemovedQuarterly',
  noRosterAutoApprove: 'noRosterAutoApprove',
  signUpPinHash: 'signUpPinHash',
  accountFeedId: 'accountFeedId',
  accountAdminFeedId: 'accountAdminFeedId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AccountScalarFieldEnum = (typeof AccountScalarFieldEnum)[keyof typeof AccountScalarFieldEnum]


export const AdminPermissionScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  userId: 'userId',
  participantId: 'participantId',
  permissionType: 'permissionType',
  liveAt: 'liveAt',
  deactivatedAt: 'deactivatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AdminPermissionScalarFieldEnum = (typeof AdminPermissionScalarFieldEnum)[keyof typeof AdminPermissionScalarFieldEnum]


export const AdminPointAwardScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId',
  participantId: 'participantId',
  amount: 'amount',
  pointTransactionId: 'pointTransactionId',
  postId: 'postId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AdminPointAwardScalarFieldEnum = (typeof AdminPointAwardScalarFieldEnum)[keyof typeof AdminPointAwardScalarFieldEnum]


export const AppNotificationScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  NotificationSeenAt: 'NotificationSeenAt',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type AppNotificationScalarFieldEnum = (typeof AppNotificationScalarFieldEnum)[keyof typeof AppNotificationScalarFieldEnum]


export const AppPermissionScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  participantId: 'participantId',
  permissionType: 'permissionType',
  deactivatedAt: 'deactivatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AppPermissionScalarFieldEnum = (typeof AppPermissionScalarFieldEnum)[keyof typeof AppPermissionScalarFieldEnum]


export const AuditScalarFieldEnum = {
  id: 'id',
  action: 'action',
  newValue: 'newValue',
  oldValue: 'oldValue',
  tableName: 'tableName',
  userId: 'userId',
  createdAt: 'createdAt'
} as const

export type AuditScalarFieldEnum = (typeof AuditScalarFieldEnum)[keyof typeof AuditScalarFieldEnum]


export const BadgeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  displayTitle: 'displayTitle',
  description: 'description',
  imageKey: 'imageKey',
  incentiveProgramId: 'incentiveProgramId',
  threshold: 'threshold',
  unit: 'unit',
  points: 'points',
  eligibilityRules: 'eligibilityRules',
  allowMultipleAward: 'allowMultipleAward',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  retiredAt: 'retiredAt'
} as const

export type BadgeScalarFieldEnum = (typeof BadgeScalarFieldEnum)[keyof typeof BadgeScalarFieldEnum]


export const BadgeEventScalarFieldEnum = {
  id: 'id',
  unit: 'unit',
  sourceId: 'sourceId',
  sourceType: 'sourceType',
  createdAt: 'createdAt',
  participantId: 'participantId'
} as const

export type BadgeEventScalarFieldEnum = (typeof BadgeEventScalarFieldEnum)[keyof typeof BadgeEventScalarFieldEnum]


export const BadgeOverrideScalarFieldEnum = {
  id: 'id',
  badgeId: 'badgeId',
  accountId: 'accountId',
  facilityId: 'facilityId',
  badgeLiveAt: 'badgeLiveAt',
  badgeRetiredAt: 'badgeRetiredAt',
  points: 'points',
  threshold: 'threshold',
  eligibilityRules: 'eligibilityRules',
  allowMultipleAward: 'allowMultipleAward',
  displayTitle: 'displayTitle',
  liveAt: 'liveAt',
  retiredAt: 'retiredAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BadgeOverrideScalarFieldEnum = (typeof BadgeOverrideScalarFieldEnum)[keyof typeof BadgeOverrideScalarFieldEnum]


export const BadgeToParticipantScalarFieldEnum = {
  id: 'id',
  badgeId: 'badgeId',
  participantId: 'participantId',
  pointTransactionId: 'pointTransactionId',
  seenAt: 'seenAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BadgeToParticipantScalarFieldEnum = (typeof BadgeToParticipantScalarFieldEnum)[keyof typeof BadgeToParticipantScalarFieldEnum]


export const BlastScalarFieldEnum = {
  id: 'id',
  status: 'status',
  accountId: 'accountId',
  title: 'title',
  content: 'content',
  createdAt: 'createdAt'
} as const

export type BlastScalarFieldEnum = (typeof BlastScalarFieldEnum)[keyof typeof BlastScalarFieldEnum]


export const CommentScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  removedAt: 'removedAt',
  removedByUserId: 'removedByUserId',
  removedByParticipantId: 'removedByParticipantId',
  isEdited: 'isEdited'
} as const

export type CommentScalarFieldEnum = (typeof CommentScalarFieldEnum)[keyof typeof CommentScalarFieldEnum]


export const ComplimentScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  facilityId: 'facilityId',
  providerId: 'providerId',
  postId: 'postId',
  content: 'content',
  status: 'status',
  manualProviderName: 'manualProviderName',
  complimenterUserId: 'complimenterUserId',
  complimenterParticipantId: 'complimenterParticipantId',
  metadata: 'metadata',
  approvedAt: 'approvedAt',
  deniedAt: 'deniedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ComplimentScalarFieldEnum = (typeof ComplimentScalarFieldEnum)[keyof typeof ComplimentScalarFieldEnum]


export const CoreValueTagScalarFieldEnum = {
  id: 'id',
  valueName: 'valueName',
  accountId: 'accountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CoreValueTagScalarFieldEnum = (typeof CoreValueTagScalarFieldEnum)[keyof typeof CoreValueTagScalarFieldEnum]


export const EventScalarFieldEnum = {
  id: 'id',
  note: 'note',
  type: 'type',
  accountId: 'accountId',
  participantId: 'participantId',
  userId: 'userId',
  createdAt: 'createdAt'
} as const

export type EventScalarFieldEnum = (typeof EventScalarFieldEnum)[keyof typeof EventScalarFieldEnum]


export const FacilityScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  name: 'name',
  status: 'status',
  scheduleURL: 'scheduleURL',
  gamesPointsBudget: 'gamesPointsBudget',
  accountId: 'accountId',
  payScheduleId: 'payScheduleId',
  scheduleCycleId: 'scheduleCycleId',
  facilityFeedId: 'facilityFeedId',
  facilityAdminFeedId: 'facilityAdminFeedId',
  publicReviewLink: 'publicReviewLink',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deactivatedAt: 'deactivatedAt',
  goLiveDate: 'goLiveDate'
} as const

export type FacilityScalarFieldEnum = (typeof FacilityScalarFieldEnum)[keyof typeof FacilityScalarFieldEnum]


export const FacilityOnPostsScalarFieldEnum = {
  postId: 'postId',
  facilityId: 'facilityId',
  updatedAt: 'updatedAt'
} as const

export type FacilityOnPostsScalarFieldEnum = (typeof FacilityOnPostsScalarFieldEnum)[keyof typeof FacilityOnPostsScalarFieldEnum]


export const FeedScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeedScalarFieldEnum = (typeof FeedScalarFieldEnum)[keyof typeof FeedScalarFieldEnum]


export const FeedSubscriptionScalarFieldEnum = {
  id: 'id',
  feedId: 'feedId',
  userId: 'userId',
  participantId: 'participantId',
  receiveNotifications: 'receiveNotifications',
  receiveSMSNotifications: 'receiveSMSNotifications',
  unsubscribedAt: 'unsubscribedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeedSubscriptionScalarFieldEnum = (typeof FeedSubscriptionScalarFieldEnum)[keyof typeof FeedSubscriptionScalarFieldEnum]


export const HistoricalFacilitySavingsScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  accountId: 'accountId',
  facilitySavings: 'facilitySavings',
  avgPerNurseSavings: 'avgPerNurseSavings',
  totalIncrementailHours: 'totalIncrementailHours',
  quarterStartDate: 'quarterStartDate',
  quarterEndDate: 'quarterEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type HistoricalFacilitySavingsScalarFieldEnum = (typeof HistoricalFacilitySavingsScalarFieldEnum)[keyof typeof HistoricalFacilitySavingsScalarFieldEnum]


export const HoursFileMappingScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  fileMatcher: 'fileMatcher',
  fileExtension: 'fileExtension',
  delimiter: 'delimiter',
  employeeIdKey: 'employeeIdKey',
  minDateKey: 'minDateKey',
  maxDateKey: 'maxDateKey',
  printDateKey: 'printDateKey',
  hoursWorkedKey: 'hoursWorkedKey',
  fileHeaders: 'fileHeaders',
  optionalKeys: 'optionalKeys',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type HoursFileMappingScalarFieldEnum = (typeof HoursFileMappingScalarFieldEnum)[keyof typeof HoursFileMappingScalarFieldEnum]


export const RosterFileMappingScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  fileMatcher: 'fileMatcher',
  fileExtension: 'fileExtension',
  delimiter: 'delimiter',
  employeeIdKey: 'employeeIdKey',
  fileHeaders: 'fileHeaders',
  optionalKeys: 'optionalKeys',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RosterFileMappingScalarFieldEnum = (typeof RosterFileMappingScalarFieldEnum)[keyof typeof RosterFileMappingScalarFieldEnum]


export const IncentivePeriodScalarFieldEnum = {
  id: 'id',
  name: 'name',
  startDate: 'startDate',
  endDate: 'endDate',
  accountId: 'accountId',
  updatedAt: 'updatedAt'
} as const

export type IncentivePeriodScalarFieldEnum = (typeof IncentivePeriodScalarFieldEnum)[keyof typeof IncentivePeriodScalarFieldEnum]


export const IncentiveProgramScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  programType: 'programType',
  programDetails: 'programDetails',
  programRules: 'programRules',
  eligibilityRules: 'eligibilityRules',
  url: 'url',
  accountId: 'accountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IncentiveProgramScalarFieldEnum = (typeof IncentiveProgramScalarFieldEnum)[keyof typeof IncentiveProgramScalarFieldEnum]


export const IncentiveProgramsOnFacilitiesScalarFieldEnum = {
  incentiveProgramId: 'incentiveProgramId',
  facilityId: 'facilityId',
  pointsForBadges: 'pointsForBadges',
  liveAt: 'liveAt',
  disabledAt: 'disabledAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  programRules: 'programRules',
  eligibilityRules: 'eligibilityRules',
  pointsBudget: 'pointsBudget'
} as const

export type IncentiveProgramsOnFacilitiesScalarFieldEnum = (typeof IncentiveProgramsOnFacilitiesScalarFieldEnum)[keyof typeof IncentiveProgramsOnFacilitiesScalarFieldEnum]


export const IngestJobScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  status: 'status',
  processed: 'processed',
  submitted: 'submitted',
  skipped: 'skipped',
  failed: 'failed',
  sourceFile: 'sourceFile',
  results: 'results'
} as const

export type IngestJobScalarFieldEnum = (typeof IngestJobScalarFieldEnum)[keyof typeof IngestJobScalarFieldEnum]


export const JobSpecialtyScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  jobCode: 'jobCode',
  jobSpecialty: 'jobSpecialty',
  gratiaSpecialty: 'gratiaSpecialty',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type JobSpecialtyScalarFieldEnum = (typeof JobSpecialtyScalarFieldEnum)[keyof typeof JobSpecialtyScalarFieldEnum]


export const EmploymentStatusMappingScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  sourceValue: 'sourceValue',
  employmentStatus: 'employmentStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EmploymentStatusMappingScalarFieldEnum = (typeof EmploymentStatusMappingScalarFieldEnum)[keyof typeof EmploymentStatusMappingScalarFieldEnum]


export const LinkMappingsScalarFieldEnum = {
  id: 'id',
  longLink: 'longLink',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt'
} as const

export type LinkMappingsScalarFieldEnum = (typeof LinkMappingsScalarFieldEnum)[keyof typeof LinkMappingsScalarFieldEnum]


export const MagicLinkOtpScalarFieldEnum = {
  id: 'id',
  phoneNumber: 'phoneNumber',
  codeHash: 'codeHash',
  attempts: 'attempts',
  expiresAt: 'expiresAt',
  consumedAt: 'consumedAt',
  createdAt: 'createdAt'
} as const

export type MagicLinkOtpScalarFieldEnum = (typeof MagicLinkOtpScalarFieldEnum)[keyof typeof MagicLinkOtpScalarFieldEnum]


export const OAuthClientScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  clientSecretHash: 'clientSecretHash',
  name: 'name',
  redirectUris: 'redirectUris',
  allowedScopes: 'allowedScopes',
  disabledAt: 'disabledAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OAuthClientScalarFieldEnum = (typeof OAuthClientScalarFieldEnum)[keyof typeof OAuthClientScalarFieldEnum]


export const OAuthAuthorizationCodeScalarFieldEnum = {
  id: 'id',
  codeHash: 'codeHash',
  clientId: 'clientId',
  userId: 'userId',
  redirectUri: 'redirectUri',
  scopes: 'scopes',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  expiresAt: 'expiresAt',
  consumedAt: 'consumedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OAuthAuthorizationCodeScalarFieldEnum = (typeof OAuthAuthorizationCodeScalarFieldEnum)[keyof typeof OAuthAuthorizationCodeScalarFieldEnum]


export const OAuthAccessTokenScalarFieldEnum = {
  id: 'id',
  tokenHash: 'tokenHash',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes',
  refreshTokenId: 'refreshTokenId',
  expiresAt: 'expiresAt',
  revokedAt: 'revokedAt',
  lastUsedAt: 'lastUsedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OAuthAccessTokenScalarFieldEnum = (typeof OAuthAccessTokenScalarFieldEnum)[keyof typeof OAuthAccessTokenScalarFieldEnum]


export const OAuthRefreshTokenScalarFieldEnum = {
  id: 'id',
  tokenHash: 'tokenHash',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes',
  familyId: 'familyId',
  expiresAt: 'expiresAt',
  rotatedAt: 'rotatedAt',
  revokedAt: 'revokedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OAuthRefreshTokenScalarFieldEnum = (typeof OAuthRefreshTokenScalarFieldEnum)[keyof typeof OAuthRefreshTokenScalarFieldEnum]


export const OAuthConsentScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes',
  revokedAt: 'revokedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OAuthConsentScalarFieldEnum = (typeof OAuthConsentScalarFieldEnum)[keyof typeof OAuthConsentScalarFieldEnum]


export const MessageScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  participantId: 'participantId',
  userId: 'userId',
  type: 'type',
  uniqueKey: 'uniqueKey',
  content: 'content',
  status: 'status',
  isTest: 'isTest',
  createdAt: 'createdAt'
} as const

export type MessageScalarFieldEnum = (typeof MessageScalarFieldEnum)[keyof typeof MessageScalarFieldEnum]


export const ModuleDataScalarFieldEnum = {
  id: 'id',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ModuleDataScalarFieldEnum = (typeof ModuleDataScalarFieldEnum)[keyof typeof ModuleDataScalarFieldEnum]


export const ModuleRunScalarFieldEnum = {
  id: 'id',
  moduleName: 'moduleName',
  liveAt: 'liveAt',
  currentStep: 'currentStep',
  finishedAt: 'finishedAt',
  facilityId: 'facilityId',
  accountId: 'accountId',
  feedId: 'feedId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ModuleRunScalarFieldEnum = (typeof ModuleRunScalarFieldEnum)[keyof typeof ModuleRunScalarFieldEnum]


export const ParticipantScalarFieldEnum = {
  id: 'id',
  autoRedeemEnabled: 'autoRedeemEnabled',
  deactivatedAt: 'deactivatedAt',
  email: 'email',
  employeeId: 'employeeId',
  employmentStatus: 'employmentStatus',
  employmentStartDate: 'employmentStartDate',
  firstName: 'firstName',
  gender: 'gender',
  birthDate: 'birthDate',
  isApproved: 'isApproved',
  isFloat: 'isFloat',
  isOptedIn: 'isOptedIn',
  isOnboarded: 'isOnboarded',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  rosterSpecialty: 'rosterSpecialty',
  jobCode: 'jobCode',
  costCenter: 'costCenter',
  salary: 'salary',
  salaryInterval: 'salaryInterval',
  shiftType: 'shiftType',
  status: 'status',
  appEnrollmentStatus: 'appEnrollmentStatus',
  totalPoints: 'totalPoints',
  showBirthdayPost: 'showBirthdayPost',
  showWorkAnniversaryPost: 'showWorkAnniversaryPost',
  allowPostTagging: 'allowPostTagging',
  allowShoutoutSms: 'allowShoutoutSms',
  version: 'version',
  isRosterExempt: 'isRosterExempt',
  accountId: 'accountId',
  facilityId: 'facilityId',
  jobSpecialtyId: 'jobSpecialtyId',
  programId: 'programId',
  preceptorId: 'preceptorId',
  userId: 'userId',
  participantFeedId: 'participantFeedId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ParticipantScalarFieldEnum = (typeof ParticipantScalarFieldEnum)[keyof typeof ParticipantScalarFieldEnum]


export const ParticipantGroupScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  type: 'type',
  accountId: 'accountId',
  facilityId: 'facilityId',
  groupFeedId: 'groupFeedId',
  visibility: 'visibility',
  deactivatedAt: 'deactivatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ParticipantGroupScalarFieldEnum = (typeof ParticipantGroupScalarFieldEnum)[keyof typeof ParticipantGroupScalarFieldEnum]


export const ParticipantToFacilityScalarFieldEnum = {
  id: 'id',
  participantId: 'participantId',
  facilityId: 'facilityId',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ParticipantToFacilityScalarFieldEnum = (typeof ParticipantToFacilityScalarFieldEnum)[keyof typeof ParticipantToFacilityScalarFieldEnum]


export const ParticipantToGroupScalarFieldEnum = {
  id: 'id',
  participantId: 'participantId',
  groupId: 'groupId',
  source: 'source',
  confidence: 'confidence',
  addedByParticipantId: 'addedByParticipantId',
  deactivatedAt: 'deactivatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ParticipantToGroupScalarFieldEnum = (typeof ParticipantToGroupScalarFieldEnum)[keyof typeof ParticipantToGroupScalarFieldEnum]


export const ParticipantSurveyScalarFieldEnum = {
  id: 'id',
  status: 'status',
  dueDate: 'dueDate',
  skips: 'skips',
  surveyId: 'surveyId',
  participantId: 'participantId',
  tenureResultsId: 'tenureResultsId',
  incentiveProgramId: 'incentiveProgramId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ParticipantSurveyScalarFieldEnum = (typeof ParticipantSurveyScalarFieldEnum)[keyof typeof ParticipantSurveyScalarFieldEnum]


export const ParticipantToIncentiveProgramScalarFieldEnum = {
  id: 'id',
  participantId: 'participantId',
  incentiveProgramId: 'incentiveProgramId',
  enrollmentDate: 'enrollmentDate',
  deactivatedAt: 'deactivatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ParticipantToIncentiveProgramScalarFieldEnum = (typeof ParticipantToIncentiveProgramScalarFieldEnum)[keyof typeof ParticipantToIncentiveProgramScalarFieldEnum]


export const PayDifferentialOrderScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  rewardName: 'rewardName',
  payDifferentialValue: 'payDifferentialValue',
  autoRedeemed: 'autoRedeemed',
  finalizationDate: 'finalizationDate',
  shiftType: 'shiftType',
  participantId: 'participantId',
  accountId: 'accountId',
  incentivePeriodId: 'incentivePeriodId',
  pointTransactionId: 'pointTransactionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type PayDifferentialOrderScalarFieldEnum = (typeof PayDifferentialOrderScalarFieldEnum)[keyof typeof PayDifferentialOrderScalarFieldEnum]


export const PayScheduleScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PayScheduleScalarFieldEnum = (typeof PayScheduleScalarFieldEnum)[keyof typeof PayScheduleScalarFieldEnum]


export const PayScheduleDatesScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  name: 'name',
  payScheduleId: 'payScheduleId',
  startDate: 'startDate',
  endDate: 'endDate',
  finalizationDate: 'finalizationDate',
  payDate: 'payDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PayScheduleDatesScalarFieldEnum = (typeof PayScheduleDatesScalarFieldEnum)[keyof typeof PayScheduleDatesScalarFieldEnum]


export const PinnedPostScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId',
  expiresAt: 'expiresAt',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PinnedPostScalarFieldEnum = (typeof PinnedPostScalarFieldEnum)[keyof typeof PinnedPostScalarFieldEnum]


export const PointTransactionScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  description: 'description',
  status: 'status',
  accountId: 'accountId',
  incentiveProgramId: 'incentiveProgramId',
  participantId: 'participantId',
  incentivePeriodId: 'incentivePeriodId',
  hideInApp: 'hideInApp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  createdBy: 'createdBy'
} as const

export type PointTransactionScalarFieldEnum = (typeof PointTransactionScalarFieldEnum)[keyof typeof PointTransactionScalarFieldEnum]


export const PointTransactionStatusEventScalarFieldEnum = {
  id: 'id',
  status: 'status',
  pointTransactionId: 'pointTransactionId',
  refundedTransactionId: 'refundedTransactionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PointTransactionStatusEventScalarFieldEnum = (typeof PointTransactionStatusEventScalarFieldEnum)[keyof typeof PointTransactionStatusEventScalarFieldEnum]


export const PostScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  content: 'content',
  type: 'type',
  visibilityStatus: 'visibilityStatus',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId',
  deletedBy: 'deletedBy',
  deletedByParticipantId: 'deletedByParticipantId',
  notifyAllParticipantsViaSMS: 'notifyAllParticipantsViaSMS',
  behaviorGroup: 'behaviorGroup',
  incentiveProgramId: 'incentiveProgramId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type PostScalarFieldEnum = (typeof PostScalarFieldEnum)[keyof typeof PostScalarFieldEnum]


export const PostParticipantTagScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  taggedParticipantId: 'taggedParticipantId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PostParticipantTagScalarFieldEnum = (typeof PostParticipantTagScalarFieldEnum)[keyof typeof PostParticipantTagScalarFieldEnum]


export const ProgramScalarFieldEnum = {
  id: 'id',
  floats: 'floats',
  name: 'name',
  shiftDuration: 'shiftDuration',
  shiftType: 'shiftType',
  accountId: 'accountId',
  employmentStatus: 'employmentStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ProgramScalarFieldEnum = (typeof ProgramScalarFieldEnum)[keyof typeof ProgramScalarFieldEnum]


export const ProgramPeriodScalarFieldEnum = {
  id: 'id',
  endDate: 'endDate',
  name: 'name',
  startDate: 'startDate',
  accountId: 'accountId',
  programId: 'programId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ProgramPeriodScalarFieldEnum = (typeof ProgramPeriodScalarFieldEnum)[keyof typeof ProgramPeriodScalarFieldEnum]


export const RawSummedHoursDataScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  employeeId: 'employeeId',
  minDate: 'minDate',
  maxDate: 'maxDate',
  printDate: 'printDate',
  hoursWorked: 'hoursWorked',
  source: 'source',
  facilityNumber: 'facilityNumber',
  facilityName: 'facilityName',
  jobCode: 'jobCode',
  jobLabel: 'jobLabel',
  employeeName: 'employeeName',
  rawData: 'rawData',
  createdAt: 'createdAt'
} as const

export type RawSummedHoursDataScalarFieldEnum = (typeof RawSummedHoursDataScalarFieldEnum)[keyof typeof RawSummedHoursDataScalarFieldEnum]


export const RawRosterDataScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  source: 'source',
  employeeId: 'employeeId',
  facilityKey: 'facilityKey',
  facilityLabel: 'facilityLabel',
  employeeName: 'employeeName',
  hireDate: 'hireDate',
  costCenter: 'costCenter',
  jobLabel: 'jobLabel',
  jobCode: 'jobCode',
  employeeGroup: 'employeeGroup',
  employeePct: 'employeePct',
  employeeHourlyRate: 'employeeHourlyRate',
  payrollArea: 'payrollArea',
  gender: 'gender',
  birthDate: 'birthDate',
  rawData: 'rawData',
  createdAt: 'createdAt'
} as const

export type RawRosterDataScalarFieldEnum = (typeof RawRosterDataScalarFieldEnum)[keyof typeof RawRosterDataScalarFieldEnum]


export const ReactionScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  removedAt: 'removedAt'
} as const

export type ReactionScalarFieldEnum = (typeof ReactionScalarFieldEnum)[keyof typeof ReactionScalarFieldEnum]


export const ReferralRewardScalarFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  referralId: 'referralId',
  pointTransactionId: 'pointTransactionId',
  createdAt: 'createdAt'
} as const

export type ReferralRewardScalarFieldEnum = (typeof ReferralRewardScalarFieldEnum)[keyof typeof ReferralRewardScalarFieldEnum]


export const ReportScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  name: 'name',
  reportType: 'reportType',
  s3ObjectKey: 's3ObjectKey',
  downloadCount: 'downloadCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type ReportScalarFieldEnum = (typeof ReportScalarFieldEnum)[keyof typeof ReportScalarFieldEnum]


export const RewardOptionScalarFieldEnum = {
  id: 'id',
  pointCost: 'pointCost',
  active: 'active',
  category: 'category',
  description: 'description',
  rewardOptionDetails: 'rewardOptionDetails',
  title: 'title',
  accountId: 'accountId',
  imageUrl: 'imageUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RewardOptionScalarFieldEnum = (typeof RewardOptionScalarFieldEnum)[keyof typeof RewardOptionScalarFieldEnum]


export const ScheduleCycleScalarFieldEnum = {
  id: 'id',
  cycle: 'cycle',
  accountId: 'accountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScheduleCycleScalarFieldEnum = (typeof ScheduleCycleScalarFieldEnum)[keyof typeof ScheduleCycleScalarFieldEnum]


export const ScheduleCycleDatesScalarFieldEnum = {
  id: 'id',
  selfScheduleOpensAt: 'selfScheduleOpensAt',
  selfScheduleClosesAt: 'selfScheduleClosesAt',
  schedulePeriodStartsAt: 'schedulePeriodStartsAt',
  schedulePeriodEndsAt: 'schedulePeriodEndsAt',
  schedulePosetedAt: 'schedulePosetedAt',
  scheduleCycleId: 'scheduleCycleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScheduleCycleDatesScalarFieldEnum = (typeof ScheduleCycleDatesScalarFieldEnum)[keyof typeof ScheduleCycleDatesScalarFieldEnum]


export const ScheduleDatesScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  name: 'name',
  payScheduleId: 'payScheduleId',
  startDate: 'startDate',
  endDate: 'endDate',
  finalizationDate: 'finalizationDate',
  payDate: 'payDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScheduleDatesScalarFieldEnum = (typeof ScheduleDatesScalarFieldEnum)[keyof typeof ScheduleDatesScalarFieldEnum]


export const ShiftPickupBadgeProgressScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  badgeId: 'badgeId',
  participantId: 'participantId',
  quarter: 'quarter',
  year: 'year',
  status: 'status',
  finalizedHoursDataId: 'finalizedHoursDataId',
  badgeToParticipantId: 'badgeToParticipantId',
  preFinalizationDate: 'preFinalizationDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ShiftPickupBadgeProgressScalarFieldEnum = (typeof ShiftPickupBadgeProgressScalarFieldEnum)[keyof typeof ShiftPickupBadgeProgressScalarFieldEnum]


export const ShiftPickupResultsScalarFieldEnum = {
  id: 'id',
  tierAchieved: 'tierAchieved',
  description: 'description',
  totalHoursWorked: 'totalHoursWorked',
  pointsAwarded: 'pointsAwarded',
  tierOrder: 'tierOrder',
  notificationSeenAt: 'notificationSeenAt',
  accountId: 'accountId',
  participantId: 'participantId',
  pointTransactionId: 'pointTransactionId',
  incentivePeriodId: 'incentivePeriodId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type ShiftPickupResultsScalarFieldEnum = (typeof ShiftPickupResultsScalarFieldEnum)[keyof typeof ShiftPickupResultsScalarFieldEnum]


export const SignUpScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  shiftType: 'shiftType',
  status: 'status',
  employmentStatus: 'employmentStatus',
  specialtyName: 'specialtyName',
  birthDate: 'birthDate',
  accountId: 'accountId',
  facilityId: 'facilityId',
  acceptTermsEventId: 'acceptTermsEventId',
  smsOptInEventId: 'smsOptInEventId',
  referrerId: 'referrerId',
  note: 'note',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SignUpScalarFieldEnum = (typeof SignUpScalarFieldEnum)[keyof typeof SignUpScalarFieldEnum]


export const SuperlativeQuestionScalarFieldEnum = {
  id: 'id',
  text: 'text',
  badgeUnit: 'badgeUnit',
  accountId: 'accountId',
  facilityId: 'facilityId',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SuperlativeQuestionScalarFieldEnum = (typeof SuperlativeQuestionScalarFieldEnum)[keyof typeof SuperlativeQuestionScalarFieldEnum]


export const SuperlativeVoteScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  voterId: 'voterId',
  voterParticipantId: 'voterParticipantId',
  superlativeQuestionId: 'superlativeQuestionId',
  accountId: 'accountId',
  facilityId: 'facilityId',
  createdAt: 'createdAt'
} as const

export type SuperlativeVoteScalarFieldEnum = (typeof SuperlativeVoteScalarFieldEnum)[keyof typeof SuperlativeVoteScalarFieldEnum]


export const SurveyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  subtitle: 'subtitle',
  description: 'description',
  callToAction: 'callToAction',
  surveyType: 'surveyType',
  behaviorGroup: 'behaviorGroup',
  accountId: 'accountId',
  facilityId: 'facilityId',
  incentiveProgramId: 'incentiveProgramId',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  moduleRunId: 'moduleRunId'
} as const

export type SurveyScalarFieldEnum = (typeof SurveyScalarFieldEnum)[keyof typeof SurveyScalarFieldEnum]


export const SurveyChoiceScalarFieldEnum = {
  id: 'id',
  choiceText: 'choiceText',
  choiceValue: 'choiceValue',
  isCorrect: 'isCorrect',
  questionId: 'questionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SurveyChoiceScalarFieldEnum = (typeof SurveyChoiceScalarFieldEnum)[keyof typeof SurveyChoiceScalarFieldEnum]


export const SurveyQuestionScalarFieldEnum = {
  id: 'id',
  icon: 'icon',
  category: 'category',
  version: 'version',
  order: 'order',
  text: 'text',
  type: 'type',
  behaviorGroup: 'behaviorGroup',
  accountId: 'accountId',
  facilityId: 'facilityId',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SurveyQuestionScalarFieldEnum = (typeof SurveyQuestionScalarFieldEnum)[keyof typeof SurveyQuestionScalarFieldEnum]


export const SurveyResponseScalarFieldEnum = {
  id: 'id',
  answer: 'answer',
  responseDate: 'responseDate',
  participantId: 'participantId',
  surveyId: 'surveyId',
  questionId: 'questionId',
  choiceId: 'choiceId',
  participantChoiceId: 'participantChoiceId',
  participantSurveyId: 'participantSurveyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SurveyResponseScalarFieldEnum = (typeof SurveyResponseScalarFieldEnum)[keyof typeof SurveyResponseScalarFieldEnum]


export const SurveyResultsScalarFieldEnum = {
  id: 'id',
  totalScore: 'totalScore',
  updatedAt: 'updatedAt',
  participantSurveyId: 'participantSurveyId',
  surveyId: 'surveyId'
} as const

export type SurveyResultsScalarFieldEnum = (typeof SurveyResultsScalarFieldEnum)[keyof typeof SurveyResultsScalarFieldEnum]


export const SurveyToAccountScalarFieldEnum = {
  accountId: 'accountId',
  surveyId: 'surveyId',
  surveyType: 'surveyType',
  identifier: 'identifier'
} as const

export type SurveyToAccountScalarFieldEnum = (typeof SurveyToAccountScalarFieldEnum)[keyof typeof SurveyToAccountScalarFieldEnum]


export const TagScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  label: 'label',
  name: 'name',
  status: 'status',
  parentTagId: 'parentTagId',
  accountId: 'accountId',
  programId: 'programId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TagScalarFieldEnum = (typeof TagScalarFieldEnum)[keyof typeof TagScalarFieldEnum]


export const TangoOrderScalarFieldEnum = {
  externalRefID: 'externalRefID',
  referenceOrderID: 'referenceOrderID',
  amount: 'amount',
  rewardName: 'rewardName',
  response: 'response',
  participantId: 'participantId',
  accountId: 'accountId',
  pointTransactionId: 'pointTransactionId',
  createdAt: 'createdAt'
} as const

export type TangoOrderScalarFieldEnum = (typeof TangoOrderScalarFieldEnum)[keyof typeof TangoOrderScalarFieldEnum]


export const TenureResultsScalarFieldEnum = {
  id: 'id',
  daysWorked: 'daysWorked',
  pointsAwarded: 'pointsAwarded',
  description: 'description',
  notificationSeenAt: 'notificationSeenAt',
  accountId: 'accountId',
  participantId: 'participantId',
  pointTransactionId: 'pointTransactionId',
  participantSurveyId: 'participantSurveyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TenureResultsScalarFieldEnum = (typeof TenureResultsScalarFieldEnum)[keyof typeof TenureResultsScalarFieldEnum]


export const TierScalarFieldEnum = {
  id: 'id',
  incentive: 'incentive',
  minHours: 'minHours',
  name: 'name',
  order: 'order',
  pointValue: 'pointValue',
  accountId: 'accountId',
  incentiveProgramId: 'incentiveProgramId',
  programId: 'programId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TierScalarFieldEnum = (typeof TierScalarFieldEnum)[keyof typeof TierScalarFieldEnum]


export const TierHistoryScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  employeeId: 'employeeId',
  participantId: 'participantId',
  programPeriodId: 'programPeriodId',
  totalHours: 'totalHours',
  tierId: 'tierId',
  source: 'source',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt'
} as const

export type TierHistoryScalarFieldEnum = (typeof TierHistoryScalarFieldEnum)[keyof typeof TierHistoryScalarFieldEnum]


export const TurnoverScalarFieldEnum = {
  id: 'id',
  currentActiveEmployeesCount: 'currentActiveEmployeesCount',
  previousMonthDeactivationCount: 'previousMonthDeactivationCount',
  previousMonthTurnoverPercentage: 'previousMonthTurnoverPercentage',
  previousMonth: 'previousMonth',
  description: 'description',
  accountId: 'accountId',
  facilityId: 'facilityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TurnoverScalarFieldEnum = (typeof TurnoverScalarFieldEnum)[keyof typeof TurnoverScalarFieldEnum]


export const UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  fullName: 'fullName',
  isSuperAdmin: 'isSuperAdmin',
  name: 'name',
  phoneNumber: 'phoneNumber',
  role: 'role',
  deactivatedAt: 'deactivatedAt',
  userFeedId: 'userFeedId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const ViewScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  viewedAt: 'viewedAt',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type ViewScalarFieldEnum = (typeof ViewScalarFieldEnum)[keyof typeof ViewScalarFieldEnum]


export const ContentSourceScalarFieldEnum = {
  id: 'id',
  key: 'key',
  title: 'title',
  type: 'type',
  location: 'location',
  accountId: 'accountId',
  deactivatedAt: 'deactivatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ContentSourceScalarFieldEnum = (typeof ContentSourceScalarFieldEnum)[keyof typeof ContentSourceScalarFieldEnum]


export const EvidenceScalarFieldEnum = {
  id: 'id',
  key: 'key',
  sourceId: 'sourceId',
  accountId: 'accountId',
  claim: 'claim',
  excerpt: 'excerpt',
  citationLabel: 'citationLabel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EvidenceScalarFieldEnum = (typeof EvidenceScalarFieldEnum)[keyof typeof EvidenceScalarFieldEnum]


export const PlayQuestionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  prompt: 'prompt',
  definition: 'definition',
  evidenceId: 'evidenceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlayQuestionScalarFieldEnum = (typeof PlayQuestionScalarFieldEnum)[keyof typeof PlayQuestionScalarFieldEnum]


export const PlaybookScalarFieldEnum = {
  id: 'id',
  key: 'key',
  title: 'title',
  description: 'description',
  imageUrl: 'imageUrl',
  badgeId: 'badgeId',
  status: 'status',
  accountId: 'accountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlaybookScalarFieldEnum = (typeof PlaybookScalarFieldEnum)[keyof typeof PlaybookScalarFieldEnum]


export const PlaybookStepScalarFieldEnum = {
  id: 'id',
  order: 'order',
  playbookId: 'playbookId',
  questionId: 'questionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlaybookStepScalarFieldEnum = (typeof PlaybookStepScalarFieldEnum)[keyof typeof PlaybookStepScalarFieldEnum]


export const PlaybookEligibilityScalarFieldEnum = {
  id: 'id',
  playbookId: 'playbookId',
  participantId: 'participantId',
  accountId: 'accountId',
  facilityId: 'facilityId',
  requiredGroupIds: 'requiredGroupIds',
  deactivatedAt: 'deactivatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlaybookEligibilityScalarFieldEnum = (typeof PlaybookEligibilityScalarFieldEnum)[keyof typeof PlaybookEligibilityScalarFieldEnum]


export const PlaybookEnrollmentScalarFieldEnum = {
  id: 'id',
  participantId: 'participantId',
  playbookId: 'playbookId',
  status: 'status',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlaybookEnrollmentScalarFieldEnum = (typeof PlaybookEnrollmentScalarFieldEnum)[keyof typeof PlaybookEnrollmentScalarFieldEnum]


export const ParticipantPlayStepScalarFieldEnum = {
  id: 'id',
  enrollmentId: 'enrollmentId',
  participantId: 'participantId',
  playbookId: 'playbookId',
  order: 'order',
  playQuestionId: 'playQuestionId',
  sourcePlaybookStepId: 'sourcePlaybookStepId',
  assignedAt: 'assignedAt',
  assignedReason: 'assignedReason'
} as const

export type ParticipantPlayStepScalarFieldEnum = (typeof ParticipantPlayStepScalarFieldEnum)[keyof typeof ParticipantPlayStepScalarFieldEnum]


export const PlaybookStepResponseScalarFieldEnum = {
  id: 'id',
  enrollmentId: 'enrollmentId',
  participantPlayStepId: 'participantPlayStepId',
  selectedChoiceIds: 'selectedChoiceIds',
  answerText: 'answerText',
  complimentId: 'complimentId',
  isCorrect: 'isCorrect',
  answeredAt: 'answeredAt'
} as const

export type PlaybookStepResponseScalarFieldEnum = (typeof PlaybookStepResponseScalarFieldEnum)[keyof typeof PlaybookStepResponseScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const AccountOrderByRelevanceFieldEnum = {
  id: 'id',
  logoURL: 'logoURL',
  name: 'name',
  programName: 'programName',
  supportEmail: 'supportEmail',
  supportURL: 'supportURL',
  adminSupportURL: 'adminSupportURL',
  scheduleURL: 'scheduleURL',
  authProviderId: 'authProviderId',
  authTenantId: 'authTenantId',
  authProduct: 'authProduct',
  tangoCustomerIdentifier: 'tangoCustomerIdentifier',
  tangoaccountIdentifier: 'tangoaccountIdentifier',
  signUpPinHash: 'signUpPinHash',
  accountFeedId: 'accountFeedId',
  accountAdminFeedId: 'accountAdminFeedId'
} as const

export type AccountOrderByRelevanceFieldEnum = (typeof AccountOrderByRelevanceFieldEnum)[keyof typeof AccountOrderByRelevanceFieldEnum]


export const AdminPermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type AdminPermissionOrderByRelevanceFieldEnum = (typeof AdminPermissionOrderByRelevanceFieldEnum)[keyof typeof AdminPermissionOrderByRelevanceFieldEnum]


export const AdminPointAwardOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId',
  participantId: 'participantId',
  pointTransactionId: 'pointTransactionId',
  postId: 'postId'
} as const

export type AdminPointAwardOrderByRelevanceFieldEnum = (typeof AdminPointAwardOrderByRelevanceFieldEnum)[keyof typeof AdminPointAwardOrderByRelevanceFieldEnum]


export const AppNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type AppNotificationOrderByRelevanceFieldEnum = (typeof AppNotificationOrderByRelevanceFieldEnum)[keyof typeof AppNotificationOrderByRelevanceFieldEnum]


export const AppPermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  participantId: 'participantId'
} as const

export type AppPermissionOrderByRelevanceFieldEnum = (typeof AppPermissionOrderByRelevanceFieldEnum)[keyof typeof AppPermissionOrderByRelevanceFieldEnum]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]


export const AuditOrderByRelevanceFieldEnum = {
  id: 'id',
  tableName: 'tableName',
  userId: 'userId'
} as const

export type AuditOrderByRelevanceFieldEnum = (typeof AuditOrderByRelevanceFieldEnum)[keyof typeof AuditOrderByRelevanceFieldEnum]


export const BadgeOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  displayTitle: 'displayTitle',
  description: 'description',
  imageKey: 'imageKey',
  incentiveProgramId: 'incentiveProgramId',
  unit: 'unit'
} as const

export type BadgeOrderByRelevanceFieldEnum = (typeof BadgeOrderByRelevanceFieldEnum)[keyof typeof BadgeOrderByRelevanceFieldEnum]


export const BadgeEventOrderByRelevanceFieldEnum = {
  id: 'id',
  unit: 'unit',
  sourceId: 'sourceId',
  sourceType: 'sourceType',
  participantId: 'participantId'
} as const

export type BadgeEventOrderByRelevanceFieldEnum = (typeof BadgeEventOrderByRelevanceFieldEnum)[keyof typeof BadgeEventOrderByRelevanceFieldEnum]


export const BadgeOverrideOrderByRelevanceFieldEnum = {
  id: 'id',
  badgeId: 'badgeId',
  accountId: 'accountId',
  displayTitle: 'displayTitle'
} as const

export type BadgeOverrideOrderByRelevanceFieldEnum = (typeof BadgeOverrideOrderByRelevanceFieldEnum)[keyof typeof BadgeOverrideOrderByRelevanceFieldEnum]


export const BadgeToParticipantOrderByRelevanceFieldEnum = {
  id: 'id',
  badgeId: 'badgeId',
  participantId: 'participantId',
  pointTransactionId: 'pointTransactionId'
} as const

export type BadgeToParticipantOrderByRelevanceFieldEnum = (typeof BadgeToParticipantOrderByRelevanceFieldEnum)[keyof typeof BadgeToParticipantOrderByRelevanceFieldEnum]


export const BlastOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  title: 'title',
  content: 'content'
} as const

export type BlastOrderByRelevanceFieldEnum = (typeof BlastOrderByRelevanceFieldEnum)[keyof typeof BlastOrderByRelevanceFieldEnum]


export const CommentOrderByRelevanceFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId',
  content: 'content',
  removedByUserId: 'removedByUserId',
  removedByParticipantId: 'removedByParticipantId'
} as const

export type CommentOrderByRelevanceFieldEnum = (typeof CommentOrderByRelevanceFieldEnum)[keyof typeof CommentOrderByRelevanceFieldEnum]


export const ComplimentOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  providerId: 'providerId',
  postId: 'postId',
  content: 'content',
  manualProviderName: 'manualProviderName',
  complimenterUserId: 'complimenterUserId',
  complimenterParticipantId: 'complimenterParticipantId'
} as const

export type ComplimentOrderByRelevanceFieldEnum = (typeof ComplimentOrderByRelevanceFieldEnum)[keyof typeof ComplimentOrderByRelevanceFieldEnum]


export const CoreValueTagOrderByRelevanceFieldEnum = {
  id: 'id',
  valueName: 'valueName',
  accountId: 'accountId'
} as const

export type CoreValueTagOrderByRelevanceFieldEnum = (typeof CoreValueTagOrderByRelevanceFieldEnum)[keyof typeof CoreValueTagOrderByRelevanceFieldEnum]


export const EventOrderByRelevanceFieldEnum = {
  id: 'id',
  note: 'note',
  accountId: 'accountId',
  participantId: 'participantId',
  userId: 'userId'
} as const

export type EventOrderByRelevanceFieldEnum = (typeof EventOrderByRelevanceFieldEnum)[keyof typeof EventOrderByRelevanceFieldEnum]


export const FacilityOrderByRelevanceFieldEnum = {
  externalId: 'externalId',
  name: 'name',
  scheduleURL: 'scheduleURL',
  accountId: 'accountId',
  facilityFeedId: 'facilityFeedId',
  facilityAdminFeedId: 'facilityAdminFeedId',
  publicReviewLink: 'publicReviewLink'
} as const

export type FacilityOrderByRelevanceFieldEnum = (typeof FacilityOrderByRelevanceFieldEnum)[keyof typeof FacilityOrderByRelevanceFieldEnum]


export const FacilityOnPostsOrderByRelevanceFieldEnum = {
  postId: 'postId'
} as const

export type FacilityOnPostsOrderByRelevanceFieldEnum = (typeof FacilityOnPostsOrderByRelevanceFieldEnum)[keyof typeof FacilityOnPostsOrderByRelevanceFieldEnum]


export const FeedOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
} as const

export type FeedOrderByRelevanceFieldEnum = (typeof FeedOrderByRelevanceFieldEnum)[keyof typeof FeedOrderByRelevanceFieldEnum]


export const FeedSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  feedId: 'feedId',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type FeedSubscriptionOrderByRelevanceFieldEnum = (typeof FeedSubscriptionOrderByRelevanceFieldEnum)[keyof typeof FeedSubscriptionOrderByRelevanceFieldEnum]


export const HistoricalFacilitySavingsOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId'
} as const

export type HistoricalFacilitySavingsOrderByRelevanceFieldEnum = (typeof HistoricalFacilitySavingsOrderByRelevanceFieldEnum)[keyof typeof HistoricalFacilitySavingsOrderByRelevanceFieldEnum]


export const HoursFileMappingOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  fileMatcher: 'fileMatcher',
  fileExtension: 'fileExtension',
  delimiter: 'delimiter',
  employeeIdKey: 'employeeIdKey',
  minDateKey: 'minDateKey',
  maxDateKey: 'maxDateKey',
  printDateKey: 'printDateKey',
  hoursWorkedKey: 'hoursWorkedKey'
} as const

export type HoursFileMappingOrderByRelevanceFieldEnum = (typeof HoursFileMappingOrderByRelevanceFieldEnum)[keyof typeof HoursFileMappingOrderByRelevanceFieldEnum]


export const RosterFileMappingOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  fileMatcher: 'fileMatcher',
  fileExtension: 'fileExtension',
  delimiter: 'delimiter',
  employeeIdKey: 'employeeIdKey'
} as const

export type RosterFileMappingOrderByRelevanceFieldEnum = (typeof RosterFileMappingOrderByRelevanceFieldEnum)[keyof typeof RosterFileMappingOrderByRelevanceFieldEnum]


export const IncentivePeriodOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  accountId: 'accountId'
} as const

export type IncentivePeriodOrderByRelevanceFieldEnum = (typeof IncentivePeriodOrderByRelevanceFieldEnum)[keyof typeof IncentivePeriodOrderByRelevanceFieldEnum]


export const IncentiveProgramOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  url: 'url',
  accountId: 'accountId'
} as const

export type IncentiveProgramOrderByRelevanceFieldEnum = (typeof IncentiveProgramOrderByRelevanceFieldEnum)[keyof typeof IncentiveProgramOrderByRelevanceFieldEnum]


export const IncentiveProgramsOnFacilitiesOrderByRelevanceFieldEnum = {
  incentiveProgramId: 'incentiveProgramId'
} as const

export type IncentiveProgramsOnFacilitiesOrderByRelevanceFieldEnum = (typeof IncentiveProgramsOnFacilitiesOrderByRelevanceFieldEnum)[keyof typeof IncentiveProgramsOnFacilitiesOrderByRelevanceFieldEnum]


export const IngestJobOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId'
} as const

export type IngestJobOrderByRelevanceFieldEnum = (typeof IngestJobOrderByRelevanceFieldEnum)[keyof typeof IngestJobOrderByRelevanceFieldEnum]


export const JobSpecialtyOrderByRelevanceFieldEnum = {
  accountId: 'accountId',
  jobCode: 'jobCode',
  jobSpecialty: 'jobSpecialty'
} as const

export type JobSpecialtyOrderByRelevanceFieldEnum = (typeof JobSpecialtyOrderByRelevanceFieldEnum)[keyof typeof JobSpecialtyOrderByRelevanceFieldEnum]


export const EmploymentStatusMappingOrderByRelevanceFieldEnum = {
  accountId: 'accountId',
  sourceValue: 'sourceValue'
} as const

export type EmploymentStatusMappingOrderByRelevanceFieldEnum = (typeof EmploymentStatusMappingOrderByRelevanceFieldEnum)[keyof typeof EmploymentStatusMappingOrderByRelevanceFieldEnum]


export const LinkMappingsOrderByRelevanceFieldEnum = {
  id: 'id',
  longLink: 'longLink'
} as const

export type LinkMappingsOrderByRelevanceFieldEnum = (typeof LinkMappingsOrderByRelevanceFieldEnum)[keyof typeof LinkMappingsOrderByRelevanceFieldEnum]


export const MagicLinkOtpOrderByRelevanceFieldEnum = {
  id: 'id',
  phoneNumber: 'phoneNumber',
  codeHash: 'codeHash'
} as const

export type MagicLinkOtpOrderByRelevanceFieldEnum = (typeof MagicLinkOtpOrderByRelevanceFieldEnum)[keyof typeof MagicLinkOtpOrderByRelevanceFieldEnum]


export const OAuthClientOrderByRelevanceFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  clientSecretHash: 'clientSecretHash',
  name: 'name',
  redirectUris: 'redirectUris',
  allowedScopes: 'allowedScopes'
} as const

export type OAuthClientOrderByRelevanceFieldEnum = (typeof OAuthClientOrderByRelevanceFieldEnum)[keyof typeof OAuthClientOrderByRelevanceFieldEnum]


export const OAuthAuthorizationCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  codeHash: 'codeHash',
  clientId: 'clientId',
  userId: 'userId',
  redirectUri: 'redirectUri',
  scopes: 'scopes',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod'
} as const

export type OAuthAuthorizationCodeOrderByRelevanceFieldEnum = (typeof OAuthAuthorizationCodeOrderByRelevanceFieldEnum)[keyof typeof OAuthAuthorizationCodeOrderByRelevanceFieldEnum]


export const OAuthAccessTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  tokenHash: 'tokenHash',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes',
  refreshTokenId: 'refreshTokenId'
} as const

export type OAuthAccessTokenOrderByRelevanceFieldEnum = (typeof OAuthAccessTokenOrderByRelevanceFieldEnum)[keyof typeof OAuthAccessTokenOrderByRelevanceFieldEnum]


export const OAuthRefreshTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  tokenHash: 'tokenHash',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes',
  familyId: 'familyId'
} as const

export type OAuthRefreshTokenOrderByRelevanceFieldEnum = (typeof OAuthRefreshTokenOrderByRelevanceFieldEnum)[keyof typeof OAuthRefreshTokenOrderByRelevanceFieldEnum]


export const OAuthConsentOrderByRelevanceFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes'
} as const

export type OAuthConsentOrderByRelevanceFieldEnum = (typeof OAuthConsentOrderByRelevanceFieldEnum)[keyof typeof OAuthConsentOrderByRelevanceFieldEnum]


export const MessageOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  participantId: 'participantId',
  userId: 'userId',
  uniqueKey: 'uniqueKey',
  content: 'content',
  status: 'status'
} as const

export type MessageOrderByRelevanceFieldEnum = (typeof MessageOrderByRelevanceFieldEnum)[keyof typeof MessageOrderByRelevanceFieldEnum]


export const ModuleDataOrderByRelevanceFieldEnum = {
  id: 'id'
} as const

export type ModuleDataOrderByRelevanceFieldEnum = (typeof ModuleDataOrderByRelevanceFieldEnum)[keyof typeof ModuleDataOrderByRelevanceFieldEnum]


export const ModuleRunOrderByRelevanceFieldEnum = {
  moduleName: 'moduleName',
  accountId: 'accountId',
  feedId: 'feedId'
} as const

export type ModuleRunOrderByRelevanceFieldEnum = (typeof ModuleRunOrderByRelevanceFieldEnum)[keyof typeof ModuleRunOrderByRelevanceFieldEnum]


export const ParticipantOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  employeeId: 'employeeId',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  rosterSpecialty: 'rosterSpecialty',
  jobCode: 'jobCode',
  costCenter: 'costCenter',
  salaryInterval: 'salaryInterval',
  accountId: 'accountId',
  programId: 'programId',
  preceptorId: 'preceptorId',
  userId: 'userId',
  participantFeedId: 'participantFeedId'
} as const

export type ParticipantOrderByRelevanceFieldEnum = (typeof ParticipantOrderByRelevanceFieldEnum)[keyof typeof ParticipantOrderByRelevanceFieldEnum]


export const ParticipantGroupOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  accountId: 'accountId',
  groupFeedId: 'groupFeedId'
} as const

export type ParticipantGroupOrderByRelevanceFieldEnum = (typeof ParticipantGroupOrderByRelevanceFieldEnum)[keyof typeof ParticipantGroupOrderByRelevanceFieldEnum]


export const ParticipantToFacilityOrderByRelevanceFieldEnum = {
  id: 'id',
  participantId: 'participantId'
} as const

export type ParticipantToFacilityOrderByRelevanceFieldEnum = (typeof ParticipantToFacilityOrderByRelevanceFieldEnum)[keyof typeof ParticipantToFacilityOrderByRelevanceFieldEnum]


export const ParticipantToGroupOrderByRelevanceFieldEnum = {
  id: 'id',
  participantId: 'participantId',
  groupId: 'groupId',
  addedByParticipantId: 'addedByParticipantId'
} as const

export type ParticipantToGroupOrderByRelevanceFieldEnum = (typeof ParticipantToGroupOrderByRelevanceFieldEnum)[keyof typeof ParticipantToGroupOrderByRelevanceFieldEnum]


export const ParticipantSurveyOrderByRelevanceFieldEnum = {
  participantId: 'participantId',
  tenureResultsId: 'tenureResultsId',
  incentiveProgramId: 'incentiveProgramId'
} as const

export type ParticipantSurveyOrderByRelevanceFieldEnum = (typeof ParticipantSurveyOrderByRelevanceFieldEnum)[keyof typeof ParticipantSurveyOrderByRelevanceFieldEnum]


export const ParticipantToIncentiveProgramOrderByRelevanceFieldEnum = {
  id: 'id',
  participantId: 'participantId',
  incentiveProgramId: 'incentiveProgramId'
} as const

export type ParticipantToIncentiveProgramOrderByRelevanceFieldEnum = (typeof ParticipantToIncentiveProgramOrderByRelevanceFieldEnum)[keyof typeof ParticipantToIncentiveProgramOrderByRelevanceFieldEnum]


export const PayDifferentialOrderOrderByRelevanceFieldEnum = {
  id: 'id',
  rewardName: 'rewardName',
  participantId: 'participantId',
  accountId: 'accountId',
  incentivePeriodId: 'incentivePeriodId',
  pointTransactionId: 'pointTransactionId'
} as const

export type PayDifferentialOrderOrderByRelevanceFieldEnum = (typeof PayDifferentialOrderOrderByRelevanceFieldEnum)[keyof typeof PayDifferentialOrderOrderByRelevanceFieldEnum]


export const PayScheduleOrderByRelevanceFieldEnum = {
  accountId: 'accountId',
  name: 'name',
  description: 'description'
} as const

export type PayScheduleOrderByRelevanceFieldEnum = (typeof PayScheduleOrderByRelevanceFieldEnum)[keyof typeof PayScheduleOrderByRelevanceFieldEnum]


export const PayScheduleDatesOrderByRelevanceFieldEnum = {
  accountId: 'accountId',
  name: 'name'
} as const

export type PayScheduleDatesOrderByRelevanceFieldEnum = (typeof PayScheduleDatesOrderByRelevanceFieldEnum)[keyof typeof PayScheduleDatesOrderByRelevanceFieldEnum]


export const PinnedPostOrderByRelevanceFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type PinnedPostOrderByRelevanceFieldEnum = (typeof PinnedPostOrderByRelevanceFieldEnum)[keyof typeof PinnedPostOrderByRelevanceFieldEnum]


export const PointTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  accountId: 'accountId',
  incentiveProgramId: 'incentiveProgramId',
  participantId: 'participantId',
  incentivePeriodId: 'incentivePeriodId',
  createdBy: 'createdBy'
} as const

export type PointTransactionOrderByRelevanceFieldEnum = (typeof PointTransactionOrderByRelevanceFieldEnum)[keyof typeof PointTransactionOrderByRelevanceFieldEnum]


export const PointTransactionStatusEventOrderByRelevanceFieldEnum = {
  id: 'id',
  pointTransactionId: 'pointTransactionId',
  refundedTransactionId: 'refundedTransactionId'
} as const

export type PointTransactionStatusEventOrderByRelevanceFieldEnum = (typeof PointTransactionStatusEventOrderByRelevanceFieldEnum)[keyof typeof PointTransactionStatusEventOrderByRelevanceFieldEnum]


export const PostOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  content: 'content',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId',
  deletedBy: 'deletedBy',
  deletedByParticipantId: 'deletedByParticipantId',
  behaviorGroup: 'behaviorGroup',
  incentiveProgramId: 'incentiveProgramId'
} as const

export type PostOrderByRelevanceFieldEnum = (typeof PostOrderByRelevanceFieldEnum)[keyof typeof PostOrderByRelevanceFieldEnum]


export const PostParticipantTagOrderByRelevanceFieldEnum = {
  id: 'id',
  postId: 'postId',
  taggedParticipantId: 'taggedParticipantId'
} as const

export type PostParticipantTagOrderByRelevanceFieldEnum = (typeof PostParticipantTagOrderByRelevanceFieldEnum)[keyof typeof PostParticipantTagOrderByRelevanceFieldEnum]


export const ProgramOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  accountId: 'accountId'
} as const

export type ProgramOrderByRelevanceFieldEnum = (typeof ProgramOrderByRelevanceFieldEnum)[keyof typeof ProgramOrderByRelevanceFieldEnum]


export const ProgramPeriodOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  accountId: 'accountId',
  programId: 'programId'
} as const

export type ProgramPeriodOrderByRelevanceFieldEnum = (typeof ProgramPeriodOrderByRelevanceFieldEnum)[keyof typeof ProgramPeriodOrderByRelevanceFieldEnum]


export const RawSummedHoursDataOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  employeeId: 'employeeId',
  source: 'source',
  facilityNumber: 'facilityNumber',
  facilityName: 'facilityName',
  jobCode: 'jobCode',
  jobLabel: 'jobLabel',
  employeeName: 'employeeName'
} as const

export type RawSummedHoursDataOrderByRelevanceFieldEnum = (typeof RawSummedHoursDataOrderByRelevanceFieldEnum)[keyof typeof RawSummedHoursDataOrderByRelevanceFieldEnum]


export const RawRosterDataOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  source: 'source',
  employeeId: 'employeeId',
  facilityKey: 'facilityKey',
  facilityLabel: 'facilityLabel',
  employeeName: 'employeeName',
  costCenter: 'costCenter',
  jobLabel: 'jobLabel',
  jobCode: 'jobCode',
  employeeGroup: 'employeeGroup',
  employeePct: 'employeePct',
  employeeHourlyRate: 'employeeHourlyRate',
  payrollArea: 'payrollArea',
  gender: 'gender'
} as const

export type RawRosterDataOrderByRelevanceFieldEnum = (typeof RawRosterDataOrderByRelevanceFieldEnum)[keyof typeof RawRosterDataOrderByRelevanceFieldEnum]


export const ReactionOrderByRelevanceFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type ReactionOrderByRelevanceFieldEnum = (typeof ReactionOrderByRelevanceFieldEnum)[keyof typeof ReactionOrderByRelevanceFieldEnum]


export const ReferralRewardOrderByRelevanceFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  referralId: 'referralId',
  pointTransactionId: 'pointTransactionId'
} as const

export type ReferralRewardOrderByRelevanceFieldEnum = (typeof ReferralRewardOrderByRelevanceFieldEnum)[keyof typeof ReferralRewardOrderByRelevanceFieldEnum]


export const ReportOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  name: 'name',
  s3ObjectKey: 's3ObjectKey',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type ReportOrderByRelevanceFieldEnum = (typeof ReportOrderByRelevanceFieldEnum)[keyof typeof ReportOrderByRelevanceFieldEnum]


export const RewardOptionOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  title: 'title',
  accountId: 'accountId',
  imageUrl: 'imageUrl'
} as const

export type RewardOptionOrderByRelevanceFieldEnum = (typeof RewardOptionOrderByRelevanceFieldEnum)[keyof typeof RewardOptionOrderByRelevanceFieldEnum]


export const ScheduleCycleOrderByRelevanceFieldEnum = {
  accountId: 'accountId'
} as const

export type ScheduleCycleOrderByRelevanceFieldEnum = (typeof ScheduleCycleOrderByRelevanceFieldEnum)[keyof typeof ScheduleCycleOrderByRelevanceFieldEnum]


export const ScheduleDatesOrderByRelevanceFieldEnum = {
  accountId: 'accountId',
  name: 'name'
} as const

export type ScheduleDatesOrderByRelevanceFieldEnum = (typeof ScheduleDatesOrderByRelevanceFieldEnum)[keyof typeof ScheduleDatesOrderByRelevanceFieldEnum]


export const ShiftPickupBadgeProgressOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  badgeId: 'badgeId',
  participantId: 'participantId',
  finalizedHoursDataId: 'finalizedHoursDataId',
  badgeToParticipantId: 'badgeToParticipantId'
} as const

export type ShiftPickupBadgeProgressOrderByRelevanceFieldEnum = (typeof ShiftPickupBadgeProgressOrderByRelevanceFieldEnum)[keyof typeof ShiftPickupBadgeProgressOrderByRelevanceFieldEnum]


export const ShiftPickupResultsOrderByRelevanceFieldEnum = {
  id: 'id',
  tierAchieved: 'tierAchieved',
  description: 'description',
  accountId: 'accountId',
  participantId: 'participantId',
  pointTransactionId: 'pointTransactionId',
  incentivePeriodId: 'incentivePeriodId'
} as const

export type ShiftPickupResultsOrderByRelevanceFieldEnum = (typeof ShiftPickupResultsOrderByRelevanceFieldEnum)[keyof typeof ShiftPickupResultsOrderByRelevanceFieldEnum]


export const SignUpOrderByRelevanceFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  specialtyName: 'specialtyName',
  accountId: 'accountId',
  acceptTermsEventId: 'acceptTermsEventId',
  smsOptInEventId: 'smsOptInEventId',
  referrerId: 'referrerId',
  note: 'note'
} as const

export type SignUpOrderByRelevanceFieldEnum = (typeof SignUpOrderByRelevanceFieldEnum)[keyof typeof SignUpOrderByRelevanceFieldEnum]


export const SuperlativeQuestionOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text',
  badgeUnit: 'badgeUnit',
  accountId: 'accountId'
} as const

export type SuperlativeQuestionOrderByRelevanceFieldEnum = (typeof SuperlativeQuestionOrderByRelevanceFieldEnum)[keyof typeof SuperlativeQuestionOrderByRelevanceFieldEnum]


export const SuperlativeVoteOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  voterId: 'voterId',
  voterParticipantId: 'voterParticipantId',
  superlativeQuestionId: 'superlativeQuestionId',
  accountId: 'accountId'
} as const

export type SuperlativeVoteOrderByRelevanceFieldEnum = (typeof SuperlativeVoteOrderByRelevanceFieldEnum)[keyof typeof SuperlativeVoteOrderByRelevanceFieldEnum]


export const SurveyOrderByRelevanceFieldEnum = {
  name: 'name',
  subtitle: 'subtitle',
  description: 'description',
  callToAction: 'callToAction',
  behaviorGroup: 'behaviorGroup',
  accountId: 'accountId',
  incentiveProgramId: 'incentiveProgramId',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId'
} as const

export type SurveyOrderByRelevanceFieldEnum = (typeof SurveyOrderByRelevanceFieldEnum)[keyof typeof SurveyOrderByRelevanceFieldEnum]


export const SurveyChoiceOrderByRelevanceFieldEnum = {
  choiceText: 'choiceText'
} as const

export type SurveyChoiceOrderByRelevanceFieldEnum = (typeof SurveyChoiceOrderByRelevanceFieldEnum)[keyof typeof SurveyChoiceOrderByRelevanceFieldEnum]


export const SurveyQuestionOrderByRelevanceFieldEnum = {
  icon: 'icon',
  text: 'text',
  behaviorGroup: 'behaviorGroup',
  accountId: 'accountId',
  createdBy: 'createdBy',
  createdByParticipantId: 'createdByParticipantId'
} as const

export type SurveyQuestionOrderByRelevanceFieldEnum = (typeof SurveyQuestionOrderByRelevanceFieldEnum)[keyof typeof SurveyQuestionOrderByRelevanceFieldEnum]


export const SurveyResponseOrderByRelevanceFieldEnum = {
  answer: 'answer',
  participantId: 'participantId',
  participantChoiceId: 'participantChoiceId'
} as const

export type SurveyResponseOrderByRelevanceFieldEnum = (typeof SurveyResponseOrderByRelevanceFieldEnum)[keyof typeof SurveyResponseOrderByRelevanceFieldEnum]


export const SurveyToAccountOrderByRelevanceFieldEnum = {
  accountId: 'accountId'
} as const

export type SurveyToAccountOrderByRelevanceFieldEnum = (typeof SurveyToAccountOrderByRelevanceFieldEnum)[keyof typeof SurveyToAccountOrderByRelevanceFieldEnum]


export const TagOrderByRelevanceFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  label: 'label',
  name: 'name',
  parentTagId: 'parentTagId',
  accountId: 'accountId',
  programId: 'programId'
} as const

export type TagOrderByRelevanceFieldEnum = (typeof TagOrderByRelevanceFieldEnum)[keyof typeof TagOrderByRelevanceFieldEnum]


export const TangoOrderOrderByRelevanceFieldEnum = {
  externalRefID: 'externalRefID',
  referenceOrderID: 'referenceOrderID',
  rewardName: 'rewardName',
  participantId: 'participantId',
  accountId: 'accountId',
  pointTransactionId: 'pointTransactionId'
} as const

export type TangoOrderOrderByRelevanceFieldEnum = (typeof TangoOrderOrderByRelevanceFieldEnum)[keyof typeof TangoOrderOrderByRelevanceFieldEnum]


export const TenureResultsOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  accountId: 'accountId',
  participantId: 'participantId',
  pointTransactionId: 'pointTransactionId'
} as const

export type TenureResultsOrderByRelevanceFieldEnum = (typeof TenureResultsOrderByRelevanceFieldEnum)[keyof typeof TenureResultsOrderByRelevanceFieldEnum]


export const TierOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  accountId: 'accountId',
  incentiveProgramId: 'incentiveProgramId',
  programId: 'programId'
} as const

export type TierOrderByRelevanceFieldEnum = (typeof TierOrderByRelevanceFieldEnum)[keyof typeof TierOrderByRelevanceFieldEnum]


export const TierHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  employeeId: 'employeeId',
  participantId: 'participantId',
  programPeriodId: 'programPeriodId',
  tierId: 'tierId',
  source: 'source'
} as const

export type TierHistoryOrderByRelevanceFieldEnum = (typeof TierHistoryOrderByRelevanceFieldEnum)[keyof typeof TierHistoryOrderByRelevanceFieldEnum]


export const TurnoverOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  accountId: 'accountId'
} as const

export type TurnoverOrderByRelevanceFieldEnum = (typeof TurnoverOrderByRelevanceFieldEnum)[keyof typeof TurnoverOrderByRelevanceFieldEnum]


export const UserOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  fullName: 'fullName',
  name: 'name',
  phoneNumber: 'phoneNumber',
  userFeedId: 'userFeedId'
} as const

export type UserOrderByRelevanceFieldEnum = (typeof UserOrderByRelevanceFieldEnum)[keyof typeof UserOrderByRelevanceFieldEnum]


export const ViewOrderByRelevanceFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  participantId: 'participantId'
} as const

export type ViewOrderByRelevanceFieldEnum = (typeof ViewOrderByRelevanceFieldEnum)[keyof typeof ViewOrderByRelevanceFieldEnum]


export const ContentSourceOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  title: 'title',
  location: 'location',
  accountId: 'accountId'
} as const

export type ContentSourceOrderByRelevanceFieldEnum = (typeof ContentSourceOrderByRelevanceFieldEnum)[keyof typeof ContentSourceOrderByRelevanceFieldEnum]


export const EvidenceOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  sourceId: 'sourceId',
  accountId: 'accountId',
  claim: 'claim',
  excerpt: 'excerpt',
  citationLabel: 'citationLabel'
} as const

export type EvidenceOrderByRelevanceFieldEnum = (typeof EvidenceOrderByRelevanceFieldEnum)[keyof typeof EvidenceOrderByRelevanceFieldEnum]


export const PlayQuestionOrderByRelevanceFieldEnum = {
  id: 'id',
  prompt: 'prompt',
  evidenceId: 'evidenceId'
} as const

export type PlayQuestionOrderByRelevanceFieldEnum = (typeof PlayQuestionOrderByRelevanceFieldEnum)[keyof typeof PlayQuestionOrderByRelevanceFieldEnum]


export const PlaybookOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  title: 'title',
  description: 'description',
  imageUrl: 'imageUrl',
  badgeId: 'badgeId',
  accountId: 'accountId'
} as const

export type PlaybookOrderByRelevanceFieldEnum = (typeof PlaybookOrderByRelevanceFieldEnum)[keyof typeof PlaybookOrderByRelevanceFieldEnum]


export const PlaybookStepOrderByRelevanceFieldEnum = {
  id: 'id',
  playbookId: 'playbookId',
  questionId: 'questionId'
} as const

export type PlaybookStepOrderByRelevanceFieldEnum = (typeof PlaybookStepOrderByRelevanceFieldEnum)[keyof typeof PlaybookStepOrderByRelevanceFieldEnum]


export const PlaybookEligibilityOrderByRelevanceFieldEnum = {
  id: 'id',
  playbookId: 'playbookId',
  participantId: 'participantId',
  accountId: 'accountId',
  requiredGroupIds: 'requiredGroupIds'
} as const

export type PlaybookEligibilityOrderByRelevanceFieldEnum = (typeof PlaybookEligibilityOrderByRelevanceFieldEnum)[keyof typeof PlaybookEligibilityOrderByRelevanceFieldEnum]


export const PlaybookEnrollmentOrderByRelevanceFieldEnum = {
  id: 'id',
  participantId: 'participantId',
  playbookId: 'playbookId'
} as const

export type PlaybookEnrollmentOrderByRelevanceFieldEnum = (typeof PlaybookEnrollmentOrderByRelevanceFieldEnum)[keyof typeof PlaybookEnrollmentOrderByRelevanceFieldEnum]


export const ParticipantPlayStepOrderByRelevanceFieldEnum = {
  id: 'id',
  enrollmentId: 'enrollmentId',
  participantId: 'participantId',
  playbookId: 'playbookId',
  playQuestionId: 'playQuestionId',
  sourcePlaybookStepId: 'sourcePlaybookStepId',
  assignedReason: 'assignedReason'
} as const

export type ParticipantPlayStepOrderByRelevanceFieldEnum = (typeof ParticipantPlayStepOrderByRelevanceFieldEnum)[keyof typeof ParticipantPlayStepOrderByRelevanceFieldEnum]


export const PlaybookStepResponseOrderByRelevanceFieldEnum = {
  id: 'id',
  enrollmentId: 'enrollmentId',
  participantPlayStepId: 'participantPlayStepId',
  selectedChoiceIds: 'selectedChoiceIds',
  answerText: 'answerText',
  complimentId: 'complimentId'
} as const

export type PlaybookStepResponseOrderByRelevanceFieldEnum = (typeof PlaybookStepResponseOrderByRelevanceFieldEnum)[keyof typeof PlaybookStepResponseOrderByRelevanceFieldEnum]

